import { Component, ComponentFactoryResolver, Input, OnInit, SimpleChanges } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
// Service
import { GenericIntegrationService } from "../../../service/generic-integration.service";
import { BroadcastService, ModalService } from "@cv-invision/core";
import { GenericFormService } from "@cv-invision/cv.invision-views.ux";
// Component
import { EditableTableComponent } from "../common/editable-table/editable-table.component";
// Model
import { IntegrationsUrlParamsModel } from "../../models/integrations-url-params.model";

@Component({
	selector: 'cv-generic-integration-base-table',
	templateUrl: '../common/editable-table/editable-table.component.html',
	providers: [ConfirmationService, MessageService]
})
export class IntegrationBaseTableComponent extends EditableTableComponent implements OnInit {
	@Input() label: string;
	@Input() model: any;
	@Input() params: IntegrationsUrlParamsModel;
	@Input() extraData: any;
	@Input() callBacks: any;
	@Input() formBuilderConfig: any;

	constructor(
		public confirmationService: ConfirmationService,
		public messageService: MessageService,
		protected service: GenericIntegrationService,
		protected modalService: ModalService,
		protected componentFactoryResolver: ComponentFactoryResolver,
		protected broadcast: BroadcastService,
		public formService: GenericFormService
	) {
		super(confirmationService, messageService, service, modalService, componentFactoryResolver, broadcast, formService);
	}

	ngOnInit(): void {
		super.setIntegrationParamsData(this.params);
		super.setIntegrationExtraData(this.extraData);
		super.ngOnInit();
	}

	/**
	 * Detect changes on values variable in order to option selected
	 * @param changes
	 */
	ngOnChanges(changes: SimpleChanges) {
		if (changes['params']) {
			super.setIntegrationParamsData(changes['params'].currentValue);
		}

		if (changes['extraData']) {
			super.setIntegrationExtraData(changes['extraData'].currentValue);
		}

		super.ngOnChanges(changes);
	}

	/**
	 * Override original onRownEditInit function
	 *
	 * @param row
	 */
	onRowEditInit(row: any) {
		if (this.callBacks && 'onRowEditInit' in this.callBacks) {
			this.callBacks.onRowEditInit(row, this.model, this.extraData);
		}
		super.onRowEditInit(row);
	}
}
